'use client';

import { type MotionStyle, useScroll, useSpring, useTransform } from 'motion/react';

const TOP_HEADER_HIDE_START = 100;
const TOP_HEADER_HIDE_END = 150;
const SEARCH_RESIZE_END = 0.25;
const LOGO_ANIMATION_END = 0.6;
const LOGO_INTERACTION_DISABLE_PROGRESS = LOGO_ANIMATION_END * 0.5;

export function useStickyHeaderAnimation(): MotionStyle {
    const { scrollY } = useScroll();

    const scrollProgress = useTransform(scrollY, [TOP_HEADER_HIDE_START, TOP_HEADER_HIDE_END], [0, 1], { clamp: true });
    const progress = useSpring(scrollProgress, { damping: 100, stiffness: 1000 });

    const mainSectionMaxHeight = useTransform(progress, [0, SEARCH_RESIZE_END, 1], ['7.5rem', '7.5rem', '4rem']);
    const searchTop = useTransform(progress, [0, SEARCH_RESIZE_END, 1], ['0rem', '0rem', '-3.25rem']);
    // 3rem / 6rem clear the menu and actions; the extra 0.5rem is 8px of space on each side.
    const searchLeft = useTransform(progress, [0, SEARCH_RESIZE_END, 1], ['0rem', '3.5rem', '3.5rem']);
    const searchRight = useTransform(progress, [0, SEARCH_RESIZE_END, 1], ['0rem', '6.5rem', '6rem']);
    const aiAssistRight = useTransform(progress, [0, SEARCH_RESIZE_END, 1], ['0rem', '6rem', '6rem']);
    const logoY = useTransform(progress, [0, LOGO_ANIMATION_END], ['0rem', '-1.25rem']);
    const logoOpacity = useTransform(progress, [0, LOGO_ANIMATION_END], [1, 0]);
    const logoScale = useTransform(progress, [0, LOGO_ANIMATION_END], [1, 0.8]);
    const logoPointerEvents = useTransform(progress, value =>
        value >= LOGO_INTERACTION_DISABLE_PROGRESS ? 'none' : 'auto'
    );

    return {
        '--header-search-top': searchTop,
        '--header-search-left': searchLeft,
        '--header-search-right': searchRight,
        '--header-ai-assist-right': aiAssistRight,
        '--header-main-section-max-height': mainSectionMaxHeight,
        '--header-logo-opacity': logoOpacity,
        '--header-logo-y': logoY,
        '--header-logo-scale': logoScale,
        '--header-logo-pointer-events': logoPointerEvents,
    } as MotionStyle;
}
